import React from "react";
import ReactDOM from "react-dom";
import { App } from "./App";

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container as Element);
root.render(<App />);
